import { Component, input, OnInit, Renderer2 } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelectModule } from '@angular/material/select';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LANGUAGE_CONFIG } from '../constants/constants';

@Component({
    selector: 'nav-strip',
    templateUrl: './nav-strip.component.html',
    styleUrl: './nav-strip.component.scss',
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, MatOption, ReactiveFormsModule, TranslatePipe]
})
export class NavStripComponent implements OnInit {
    private defaultFontSize = 16;
    collapsed = input.required<boolean>();
    activeButton: 'decrease' | 'reset' | 'increase' = 'reset';
    activeTheme: 'light' | 'dark' = 'light';
    languageConfig = LANGUAGE_CONFIG;
    languageControl = new FormControl(LANGUAGE_CONFIG[0], { nonNullable: true });

    constructor(
        private renderer: Renderer2,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.translate.use(this.languageControl.value.langCode);
        this.languageControl.valueChanges.subscribe((value) => this.translate.use(value.langCode));
    }

    changeFontSize(action: 'decrease' | 'reset' | 'increase') {
        this.activeButton = action;
        if (action === 'reset') {
            this.defaultFontSize = 16;
        } else if (action === 'decrease' && this.defaultFontSize > 10) {
            this.defaultFontSize -= 1;
        } else if (action === 'increase' && this.defaultFontSize < 22) {
            this.defaultFontSize += 1;
        }
        this.renderer.setStyle(document.documentElement, 'font-size', `${this.defaultFontSize}px`);
        this.renderer.setStyle(document.body, 'font-size', `${this.defaultFontSize}px`);
        this.applyGlobalStyle(`html, body { font-size: ${this.defaultFontSize}px !important; }`);
    }

    applyGlobalStyle(css: string) {
        let styleTag = document.getElementById('global-font-size');
        if (!styleTag) {
            styleTag = document.createElement('style');
            styleTag.id = 'global-font-size';
            document.head.appendChild(styleTag);
        }
        styleTag.innerHTML = css;
    }

    changeTheme(theme: 'light' | 'dark') {
        if (theme === 'light') {
            this.renderer.addClass(document.body, 'dark-theme');
            this.activeTheme = 'dark';
        } else {
            this.renderer.removeClass(document.body, 'dark-theme');
            this.activeTheme = 'light';
        }
    }
}
